import React from 'react';
import './MintNftDisplay.css';

export default function MintNftDetails({ metadata, offer, priceLabel, royaltyBasisPoints, collectionName }) {
    const limited = !!offer && offer.editionMode !== 'OPEN';
    const attributes = Array.isArray(metadata?.attributes) ? metadata.attributes.filter(attribute => attribute && (attribute.trait_type || attribute.name)) : [];
    const royalties = royaltyBasisPoints == null || !Number.isFinite(Number(royaltyBasisPoints))
        ? 'Not available' : `${Number(royaltyBasisPoints) / 100}% on secondary sales`;
    return <div className="mint-nft-details">
        {metadata?.description && <p className="mint-nft-description">{metadata.description}</p>}
        <dl className="mint-nft-facts">
            <div><dt>Scarcity</dt><dd>{limited ? 'Limited edition' : 'Open edition'}
                {limited && offer.supply != null && <span> &middot; {offer.supply} total</span>}
                {offer && <small>{offer.mintedCount || 0}{limited && offer.supply != null ? ` of ${offer.supply}` : ''} minted</small>}</dd>
            </div>
            <div><dt>Mint price</dt><dd>{priceLabel}</dd></div>
            <div><dt>Royalties</dt><dd>{royalties}</dd></div>
            <div><dt>NFT standard</dt><dd>{offer?.assetStandard === 'COMPRESSED' ? 'Compressed NFT' : 'Core NFT'}</dd></div>
            {collectionName && <div><dt>Collection</dt><dd>{collectionName}</dd></div>}
        </dl>
        <p className="mint-nft-fee-note">The mint price includes any platform sales commission. NFT creation and network fees are additional. {offer
            ? offer.archiveProvider === 'IRYS' && offer.archiveStrategy === 'ARCHIVE_ON_FIRST_MINT' && offer.archiveStatus !== 'READY'
                ? 'The first collector also funds a separate publishing storage payment; review its quote before approval.' : ''
            : 'Artwork and metadata storage costs are additional.'}</p>
        {attributes.length > 0 && <dl className="mint-nft-attributes" aria-label="NFT attributes">
            {attributes.map((attribute, index) => <div key={index}>
                <dt>{attribute.trait_type || attribute.name}</dt><dd>{String(attribute.value ?? '')}</dd>
            </div>)}
        </dl>}
    </div>;
}
